import Cookies from 'js-cookie';

export const COOKIE_NAMES = {
  PROJECT_VIEW: 'project_view',
};

export const allspiceCookies = Cookies.withAttributes({
  path: `${window.config.appSubUrl}/`,
  expires: 365, // days
});
